module.exports = __webpack_public_path__ + "img/red_066.a7abe1dd.png";